export default "__VITE_ASSET__Br4K7rQ9__"